module.exports = __webpack_public_path__ + "704a1c82e3b114eb2b56e335288f888c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/4_D#2.mp3
// module id = 61
// module chunks = 0